import React from 'react';
export function Footer() {
  return <footer className="py-6 bg-dark text-white/70" data-id="element-105">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-106">
        <p className="text-sm mb-4" data-id="element-107">
          © {new Date().getFullYear()} The Home Healing Handbook — All Rights
          Reserved
        </p>
        <p className="text-xs text-white/50 max-w-2xl mx-auto" data-id="element-108">
          Digital product with instant access after payment. This product is not
          intended to diagnose, treat, cure, or prevent any disease. Always
          consult a qualified healthcare provider for serious medical
          conditions.
        </p>
      </div>
    </footer>;
}